// extracted by mini-css-extract-plugin
export default {"wrapper":"SidebarButtons_wrapper__cCZDw","likeAnimation":"SidebarButtons_likeAnimation__JWb0B"};